import { QuerySelector } from "../../components/productListingPage/productListingPage";
export interface TypeValue {
    type: string;
    value: string;
}
export namespace PrettyUrlUtilities {
    export function filterUrlMatchesEquivelantPrettyUrl(querySelectorString: string) {
        let path = location.pathname + location.search;
        return prettySegemntsMatchQuerySelectorValueStrings(querySelectorString, path);

    }

    export function prettySegemntsMatchQuerySelectorValueStrings(querySelectorString: string, prettyUrl: string): boolean {
        
        var prettyUrlArray = getPrettyUrlAsArray(prettyUrl);
        var queryValueStringArray = getQuerySelectorNameStrings(querySelectorString)
        if (queryValueStringArray.length === prettyUrlArray.length && includesAll(prettyUrlArray, queryValueStringArray)) {
            return true;
        } else {
            return false;
        }
    }
    export function getQuerySelectorNameStrings(querySelectorString: string) {
        try {
            var querySelectorArray: TypeValue[] = createQuerySelectorArrayFromString(querySelectorString);
            let querySelectoryStringNames = new Array<string>();
            for (let i = 0; i < querySelectorArray.length; i += 1) {
                if (querySelectorArray[i].value.includes('_')) {
                    let currentName = querySelectorArray[i].value.split('_')[1];
                    querySelectoryStringNames.push(currentName);
                }

            }
            
            return querySelectoryStringNames;
        } catch(error) {
            console.log('PrettyUrlUtilities: getQuerySelectorNameStrings Error', error);
            return new Array<string>();
        }
    }
    export function createQuerySelectorArrayFromString(querySelectorString: string): TypeValue[] {
        if (querySelectorString === '') {
            querySelectorString = 'page--1';
        }
        let queryPiecesStringArray = querySelectorString.split('--');
        let querySelectorArray: TypeValue[] = new Array<TypeValue>();
        for (let i = 0; i < queryPiecesStringArray.length; i += 2) {
            let currentQuerySelector: TypeValue = { type: queryPiecesStringArray[i], value: queryPiecesStringArray[i + 1] };
            querySelectorArray.push(currentQuerySelector);
        }
        return querySelectorArray;

    }
    const includesAll = (arr: string[], values: string[]) => values.every(v => arr.includes(v));
    export function getPrettyUrlAsArray(prettuUrlString: string): string[] {
        let prettyUrlArray = new Array<string>();
        let prettyUrlArrayWithEmpty = prettuUrlString.split('/');
        prettyUrlArray =  prettyUrlArrayWithEmpty.filter(function (el) {
            return el !== null && el !== '';
        });

        return prettyUrlArray;
    }
}